<template>
  <div>
    <Breadcrumbs main="Beacon" title="Sms" />
    <div class="container-fluid">
      <div class="card p-4">
        <dataTableVue
          ref="refDataTable"
          :isSearch="false"
          :isFilter="true"
          :isExport="true"
          v-bind:data="{
            module: 'beacon',
            columns: columns,
            rows: rows,
            filter_custom: 'filterCustomSms',
            exportDetail: exportDetail,
          }"
          @load="loadItems"
          @openModal="openModal"
        >
        </dataTableVue>
      </div>
    </div>
  </div>
</template>

<script>
  import { requestService } from '../../../_services';

  export default {
    data() {
      return {
        isEdit: null,
        show: false,
        columns: [
          {
            label: 'Date',
            field: 'created_at',
            hidden: false,
          },
          {
            label: 'Incident ID',
            field: 'incident',
            hidden: false,
          },
          {
            label: 'Summary',
            field: 'description',
            hidden: false,
          },
          {
            label: 'Announcement',
            field: 'announcement_type',
            hidden: false,
          },
          {
            label: 'Phone',
            field: 'phone',
            hidden: false,
          },
          {
            label: 'Status',
            field: 'call_status',
            hidden: false,
          },
        ],
        rows: [],
        exportDetail: {
          fileName: 'export_report_sms',
          exportUrl: '',
        },
      };
    },
    mounted() {
      setTimeout(() => this.loadItems(), 1000);
    },
    methods: {
      openModal(value) {
        this.show = !this.show;
        value.match('add') ? (this.isEdit = false) : (this.isEdit = true);
      },
      async loadItems(event) {
        var str = '';
        if (event != undefined) {
          for (var key in event.params) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.params[key]);
          }
          this.columns.forEach((element) => {
            if (event.sortField == element.field) {
              if (
                event.sortField == 'created_at' ||
                event.sortField == 'updated_at'
              ) {
                str += '&' + 'sortField=' + event.sortField;
              } else {
                str += '&' + 'sortField=' + element.field;
              }
            }
          });
          if (event.filter != undefined) {
            for (var key in event.filter) {
              if (str != '') {
                str += '&';
              }
              str += key + '=' + encodeURIComponent(event.filter[key]);
            }
          }
        }
        if (str == '') {
          str = 'sortType=desc&sortField=created_at';
        }
        var url = '/api/report/sms/filter?' + str;
        this.exportDetail.exportUrl = '/api/report/sms/export?' + str;
        return requestService
          .GetFetch('beacon', url)
          .then((response) => {
            if (response.status == 200) {
              response.text().then((text) => {
                let self = this;
                self.rows = [];
                const data = text && JSON.parse(text);
                if (data.data.data != null) {
                  self.json_data = data.data.data;
                  self.rows = data.data.data;
                  self.$refs.refDataTable.setTotalRecords(data.data.total);
                  self.$refs.refDataTable.setPages(data.data.current_page);
                } else {
                  self.$refs.refDataTable.setTotalRecords(0);
                  self.$refs.refDataTable.setPages(1);
                }
              });
            }
          })
          .catch((error) => {
            this.$notify({ text: error, type: 'danger' });
          });
      },
    },
  };
</script>

<style></style>
